export default (condition, elements) => (condition ? elements : []);
